import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { RootState } from "features/config/store";
import { StockInventoryCurrentStock } from "features/stock-ordering/core/domain/stock-inventory.model";
import { FetchCurrentStockparam } from "features/stock-ordering/core/stock-ordering.params";
import {
  stockInventoryFetchCurrentStockResponse,
  stockInventoryFetchCurrentStockRepository,
} from "features/stock-ordering/data/stock-ordering.repository";

export enum StockInventoryFetchCurrentStockState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: StockInventoryFetchCurrentStockState;
  message: string;
  data: StockInventoryCurrentStock | undefined;
}

const initialState: InitialState = {
  status: StockInventoryFetchCurrentStockState.initial,
  message: "",
  data: undefined,
};

export const stockInventoryFetchCurrentStock = createAsyncThunk(
  "stockInventoryFetchCurrentStock",
  async (param: FetchCurrentStockparam, { rejectWithValue }) => {
    try {
      const response: stockInventoryFetchCurrentStockResponse =
        await stockInventoryFetchCurrentStockRepository(param);
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const stockInventoryFetchCurrentStockSlice = createSlice({
  name: "stockInventoryFetchCurrentStock",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(stockInventoryFetchCurrentStock.pending, (state) => {
        state.status = StockInventoryFetchCurrentStockState.inProgress;
      })
      .addCase(stockInventoryFetchCurrentStock.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = StockInventoryFetchCurrentStockState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(stockInventoryFetchCurrentStock.rejected, (state, action) => {
        state.status = StockInventoryFetchCurrentStockState.fail;
        state.message = action.payload as string;
        state.data = undefined;
      });
  },
});

export const selectStockInventoryFetchCurrentStock = (state: RootState) =>
  state.stockInventoryFetchCurrentStock;

export default stockInventoryFetchCurrentStockSlice.reducer;
